'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ModalTitle = require('react-bootstrap/lib/ModalTitle');

var _ModalTitle2 = _interopRequireDefault(_ModalTitle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ModalTitle2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@sketchpixy/rubix/lib/ModalTitle.js
// module id = 644
// module chunks = 0